import React from "react";

function ClubIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M5.6 8.222c1.768 0 3.2-1.393 3.2-3.11C8.8 3.392 7.368 2 5.6 2 3.833 2 2.4 3.393 2.4 5.111c0 1.718 1.433 3.111 3.2 3.111zm5.2 0c1.547 0 2.8-1.217 2.8-2.722 0-1.504-1.253-2.722-2.8-2.722-.628 0-1.201.208-1.668.547.288.538.468 1.14.468 1.786 0 .863-.298 1.656-.79 2.302a2.83 2.83 0 001.99.81zm-.468 6.223c.48 0 .868-.377.868-.844 0-2.326-1.94-4.212-4.332-4.212H4.333C1.939 9.389 0 11.275 0 13.6c0 .467.388.844.867.844h9.465zm4.868 0c.443 0 .8-.35.8-.8 0-2.127-1.79-3.867-4.022-3.867H10.13C11.28 10.694 12 12.065 12 13.6c0 .311-.095.598-.25.844h3.45z"
        ></path>
      </g>
    </svg>
  );
}

export default React.memo(ClubIcon);
